import React from "react";
import { limitNotif } from "helpers/notificationHelper";
import { AppMenuLink } from "../AppMenuLink";

interface ExpandableMenuChildItemProps {
	name: string;
	count?: number;
	icon?: React.ReactNode;
	isActive: boolean;
	link: string;
	testId?: string;
	tourName?: string;
	onClick?: (e: React.MouseEvent) => void;
	onNavigate?: () => void;
}

export const ExpandableMenuChildItem: React.FC<ExpandableMenuChildItemProps> = ({
	isActive,
	link,
	name,
	count,
	icon,
	testId,
	tourName,
	onClick,
	onNavigate,
}) => {
	const hasCount = count !== undefined;

	const content = (
		<div className="flex w-full items-center py-1.5 pr-4">
			{icon && (
				<div
					className={`mr-2 flex shrink-0 items-center ${isActive ? "text-royal-blue" : "text-gray-400 group-hover:text-royal-blue"}`}
				>
					{icon}
				</div>
			)}
			<div
				className="flex flex-1 items-center justify-between"
				style={{ fontSize: "14px", lineHeight: "20px" }}
			>
				<span
					className={`font-roboto ${isActive ? "text-royal-blue" : "text-gray-600 group-hover:text-royal-blue"}`}
					style={{ fontWeight: isActive ? 500 : 400 }}
				>
					{name}
				</span>
				{hasCount && (
					<div
						className="ml-2 flex items-center justify-center rounded-full border border-quarternary-400 bg-gray-utility-100"
						style={{
							fontSize: "11px",
							padding: "1px 6px",
							minWidth: "24px",
							height: "20px",
						}}
					>
						<span className="font-roboto font-semibold text-secondary-700">
							{limitNotif(count)}
						</span>
					</div>
				)}
			</div>
		</div>
	);

	const wrapperClasses = `group py-1 pl-2 ${isActive ? "bg-[rgba(0,69,245,0.2)]" : "hover:bg-utility-blue-light-50"}`;
	const linkClasses = `flex w-full items-center text-gray-500 font-medium !bg-transparent ${tourName}`;

	return (
		<div
			className={wrapperClasses}
			data-testid={testId}
		>
			{onClick ? (
				<a
					href={link}
					onClick={onClick}
					className={linkClasses}
					data-testid={testId ? `${testId}-link` : undefined}
				>
					{content}
				</a>
			) : (
				<AppMenuLink
					to={link}
					testId={testId ? `${testId}-link` : undefined}
					onNavigate={onNavigate}
					className={linkClasses}
				>
					{content}
				</AppMenuLink>
			)}
		</div>
	);
};
